module.exports = __webpack_public_path__ + "img/vg.3d600437.svg";